import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  list: [], // 포인트 적립내역
  pageInfo: { totalPage: 2, page: 1 },
  condition: {
    userNo: 0,
    page: 1,
    limit: 10,
    action: 'EARN'
  },

  totalPoint: 0 // 보유 포인트
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
